<template>
  <div>
    <div v-if="bookingEntryFilterable.getBookingEntries(true).length" class="w-100">
      <v-row
        v-for="(timeEntries, timeEntriesIndex) in entriesByTime"
        :key="timeEntriesIndex"
        class="content-5 page-break-after"
      >
        <!-- iterate lunch time -->
        <v-col class="col-12">
          <!-- title -->
          <single-report-header :title="report.getTitle()" :date="date" />

          <!-- headline -->
          <single-report-group-by-header
            :title="timeEntries.title"
            :right-title="`${$t(
              'singleReport.total'
            )}: <span class='font-weight-black'>${bookingEntryFilterable.getTotalPeopleCount(true)}</span> ${$t(
              'singleReport.peopleOverAll'
            )}`"
          />

          <!-- header -->
          <v-row class="font-weight-black">
            <!-- amount of people-->
            <v-col class="col-1">
              {{ $t('bookingComplete.people') }}
            </v-col>

            <!-- user name -->
            <v-col class="col-2">
              {{ $t('shopBackendBookingOverview.customer') }}
            </v-col>

            <!-- address -->
            <v-col class="col-2">
              {{ $t('general.address') }}
            </v-col>

            <!-- mail -->
            <v-col class="col-3">
              {{ $t('general.email') }}
            </v-col>

            <!-- phone -->
            <v-col class="col-2">
              {{ $t('general.phone') }}
            </v-col>

            <!-- note -->
            <v-col class="col-2">
              {{ $t('extraRides.comment') }}
            </v-col>
          </v-row>

          <!-- iterate booking entries -->
          <v-row
            v-for="(bookingEntry, bookingEntryIndex) in timeEntries.entries"
            :key="bookingEntryIndex"
            class="border-top"
            :class="{
              'page-break-after':
                bookingEntryIndex > 0 && bookingEntryIndex % 15 === 0,
              'pt-12': bookingEntryIndex > 0 && bookingEntryIndex % 16 === 0,
            }"
            :variable="(buyer = bookingEntry.getBooking().getBuyer())"
          >
            <!-- amount of people-->
            <v-col class="col-1 py-1">
              {{ bookingEntry.getPeopleCount() }}
            </v-col>

            <!-- user name -->
            <v-col class="col-2 py-1">
              <p v-if="buyer.getCompany()" class="my-0">
                {{ buyer.getCompany() }}
              </p>
              {{ buyer.getFullName() }}
            </v-col>

            <!-- address -->
            <v-col class="col-2 py-1">
              {{ buyer.getAddress() }}
            </v-col>

            <!-- mail -->
            <v-col class="col-3 py-1">
              {{ buyer.getMail() }}
            </v-col>

            <!-- phone -->
            <v-col class="col-2 py-1">
              {{ buyer.getPhone() }}
            </v-col>

            <!-- note -->
            <v-col class="col-2 py-1">
              {{ bookingEntry.getBooking().getNote() }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <!-- no booking entries -->
    <v-row v-else>
      <!-- title -->
      <single-report-header :title="report.getTitle()" :date="date" />
      <v-col class="col-12 content-2">
        <span class="fal fa-folder-open mr-2" />
        {{ $t('singleReport.noContent') }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ReportMixin from '../ReportMixin'
import SingleReportHeader from '../SingleReportHeader'
import SingleReportGroupByHeader from '../SingleReportGroupByHeader'

export default {
  name: 'ReportNiesenLunch',
  components: { SingleReportGroupByHeader, SingleReportHeader },
  mixins: [ReportMixin],

  computed: {
    // group booking entries by time
    entriesByTime() {
      let bookingEntries = this.bookingEntryFilterable.getBookingEntries(true)
      if (bookingEntries.length) {
        let entriesByTime = [
          {
            time: '12h',
            title: '11.45 Uhr',
            entries: [],
          },
          {
            time: '13h',
            title: '12.15 Uhr',
            entries: [],
          },
          {
            time: '14h',
            title: '12.45 Uhr',
            entries: [],
          },
          {
            time: '15h',
            title: '13.15 Uhr',
            entries: [],
          },
          {
            time: '16h',
            title: '13.45 Uhr',
            entries: [],
          },
        ]

        // iterate booking entries
        for (let i = 0; i < bookingEntries.length; i++) {
          let entry = bookingEntries[i]
          let translation = entry.productDefinitionTranslation
          if (translation.includes('12h'))
            entriesByTime
              .find((entry) => entry.time === '12h')
              .entries.push(entry)
          if (translation.includes('13h'))
            entriesByTime
              .find((entry) => entry.time === '13h')
              .entries.push(entry)
          if (translation.includes('14h'))
            entriesByTime
              .find((entry) => entry.time === '14h')
              .entries.push(entry)
          if (translation.includes('15h'))
            entriesByTime
              .find((entry) => entry.time === '15h')
              .entries.push(entry)
          if (translation.includes('16h'))
            entriesByTime
              .find((entry) => entry.time === '16h')
              .entries.push(entry)
        }
        // sort by booking id. closes https://pricenow.atlassian.net/browse/T1-701
        for (let i = 0; i < entriesByTime.length; i++) {
          entriesByTime[i].entries.sort((a, b) => a.booking.id - b.booking.id)
        }
        return entriesByTime
      }
      return []
    },
  },

  mounted() {
    // via mixin!
    this.loadBookingEntriesFilterable(10003)
  },
}
</script>
